// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/style/base.css
// module id = 11
// module chunks = 1 2 3 4 5 6